import React from "react";
import { Chip } from "@mui/material";
import SinglePageDocumentIcon from "../../../../../static/assets/images/stay_compliant/single_page_document.svg";

export type SingleRecordCardProps = {
  title: string;
  description?: React.ReactNode | string;
  iconComponent?: React.ReactNode;
  chipText?: string;
  chipColor?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"; // (from MUI Chip.d.ts)
  chipVariant?: "muted" | "filled" | "outlined"; // (from MUI Chip.d.ts)
  buttons?: React.ReactNode; // Note: this is inside a `tw-boundary` so MUI components (e.g. Button) are discouraged :)
  cardStyle?: any; // Optional {prop: value} `style` object for the containing card.
};

/**
 * A card representing a single record or document (generic) with optional icon, corner chip, and action button row.
 *
 */
export const SingleRecordCard = ({
  title,
  description = null,
  iconComponent = <SinglePageDocumentIcon />,
  chipText = null,
  chipColor = "default",
  chipVariant = "filled",
  buttons = null,
  cardStyle = null,
}: SingleRecordCardProps) => {
  return (
    <div className="tw-boundary" style={cardStyle}>
      <div className="border-2 border-gray-200 rounded-lg px-md py-md">
        <div className="flex gap-x-1.5">
          {iconComponent}
          <h5 className="font-bold">{title}</h5>
          {chipText && (
            <Chip
              label={chipText}
              color={chipColor}
              variant={chipVariant}
              style={{ marginLeft: "auto" /* (float right) */ }}
            />
          )}
        </div>
        <p>{description}</p>
        <div>{buttons}</div>
      </div>
    </div>
  );
};
